<template>
    <div class="chart">
    <v-chart :forceFit="true" :height="height" :data="data" :scale="scale" :padding="padding">
      <v-tooltip :showTitle="false" dataKey="levelName*percent" />
      <v-axis />
      <v-legend dataKey="levelName" />
      <v-pie
        position="percent"
        type="intervalStack"
        :color="color"
        :label="labelConfig"
        :tooltip="tooltip"
        :v-style="pieStyle"
        :select="select"
      />
      <v-coord type="theta" :radius="0.75" />
    </v-chart>
    <ul class="legend" v-if="data.length">
        <li v-for="(item, i) in data" :key="item && item.levelId">
          <span
            class="dot"
            :style="{
              backgroundColor: colors[i],
              boxShadow: shadows[i]
            }"
          />
          <span class="legendTitle">{{item.levelName}}</span>
          <span class="value">{{item.studentNum}}人</span>
        </li>
    </ul>
  </div>
</template>

<style lang="stylus" scoped>
  .chart {
    position: relative;
  }
   .legend {
    width: 100%;
    margin: 0 20px;
    padding: 0;
    list-style: none;

    li {

      position: relative;
      width: 100%;
      display: inline-block;
      padding-left: 30px;
      // text-align: center;
      height: 22px;
      margin-bottom: 16px;
      line-height: 22px;
      cursor: pointer;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .dot {
    position: relative;
    top: -1px;

    display: inline-block;
    width: 36px;
    height: 6px;
    margin-right: 8px;
    border-radius: 4px;
  }
  .line {
    display: inline-block;
    width: 1px;
    height: 16px;
    margin-right: 8px;
    background-color: #e8e8e8;
  }
  .legendTitle {
    // color: @text-color;
    margin-right: 20px;
  }
  .title {
    margin-bottom: 8px;
  }

</style>
<script>
import { DataView } from '@antv/data-set'
import { toPercent } from '@/utils'
import { cloneDeep } from 'lodash'
export default {

  data() {
    return {
      data: [],
      scale: [{
        dataKey: 'levelName',
        min: 0,
        formatter: '.0%'
        // type: 'cat',
        // range: [0, 1],
      },
      {
        dataKey: 'studentNum',
        min: 0
      }],
      select: [true, {
        mode: 'single', // 选中模式，单选、多选
        style: {
          lineWidth: 1,
          color: '#fff'
        }, // 选中后 shape 的样式
        cancelable: true, // 选中之后是否允许取消选中，默认允许取消选中
        animate: true// 选中是否执行动画，默认执行动画
      }],
      pieStyle: {
        stroke: '#fff',
        lineWidth: 1
      },
      tooltip: [
        'percent*type',
        (percent, type) => {
          return {
            name: type,
            value: toPercent(percent)
          }
        }
      ],
      labelConfig: ['percent', {
        formatter: (val) => {
          return toPercent(val)
        }
      }],
      color: [
        'levelName',
        this.colors
      ]
    }
  },
  props: {
    height: {
      type: Number,
      default: 270
    },
    padding: {
      type: Array,
      default: () => ([12, 20, 12, 20])
    },
    lineWidth: {
      type: Number,
      default: 1
    },
    loading: Boolean,
    hasLegend: Boolean,
    subTitle: String,
    colors: Array,
    shadows: Array,
    total: Number,
    sourceData: Array,
    ringStyle: Object
  },
  watch: {
    sourceData() {
      if (this.sourceData.length) {
        this.initChart()
      }
    },
    colors(val) {
      this.color = [
        'levelName',
        val
      ]
    }
  },
  methods: {
    initChart () {
      // 防止不停更新this.sourceData导致init不停触发
      const sourceData = cloneDeep(this.sourceData)

      if (!sourceData.length) { return }
      const dv = new DataView()
      dv.source(sourceData).transform({
        type: 'percent',
        field: 'studentNum',
        dimension: 'levelName',
        as: 'percent'
      })
      this.$data.data = dv.rows
    },
    handleLegendClick(item) {
      this.scoreData = item
      this.dialogVisible = true
    }
  },
  mounted() {
  }
}
</script>
